const actionTypeIdentifier = "BC7C77AF-6198-4DC5-9D71-B4BE2B641A4F";

export const setLocationSiteHistoryLogsLoading = `SET-LOCATION-SITE-HISTORY-LOGS-LOADING-${actionTypeIdentifier}`;
export const getLocationSiteHistoryLogs = `GET-LOCATION-SITE-HISTORY-LOGS-${actionTypeIdentifier}`;
export const setLocationSiteHistoryPageSize = `SET-LOCATION-SITE-HISTORY-PAGE-SIZE-${actionTypeIdentifier}`;
export const resetLocationSiteHistory = `RESET-LOCATION-SITE-HISTORY-${actionTypeIdentifier}`;
export const setLocationSiteColSearchStr = `SET-LOCATION-SITE-HISTORY-COL-SEARCH-${actionTypeIdentifier}`;